import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const SMALL_ELECTRIC_VEHICLE = {
  nickname: 'PRODUCTS.SMALL_ELECTRIC_VEHICLE.shortname',
  properties: [
    { name: 'make', key: 'MAKE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'driverBirthYear', key: 'DRIVER_BIRTH_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },

    { name: 'serialNumber', key: 'SERIAL_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE_SMALL_ELECTRIC_VEHICLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' }
        ]
      }
    },
  ],
  icon:'small-electric-vehicle'
};
